import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import styled from 'styled-components';
import { toCx } from './classname.js';

var _excluded = ["m", "mt", "mb", "mx", "my", "ms", "me"],
  _excluded2 = ["p", "pt", "pb", "px", "py", "ps", "pe"];
var marginMap = {
  r: 'marginRight',
  l: 'marginLeft'
};
var paddingMap = {
  r: 'paddingRight',
  l: 'paddingLeft'
};
var marginStartMap = {
  ltr: marginMap.l,
  rtl: marginMap.r
};
var marginEndMap = {
  ltr: marginMap.r,
  rtl: marginMap.l
};
var paddingStartMap = {
  ltr: paddingMap.l,
  rtl: paddingMap.r
};
var paddingEndMap = {
  ltr: paddingMap.r,
  rtl: paddingMap.l
};

/**
 * Get spacing theme value and convert spacing properties into CSS properties
 *
 * @param props Component props
 * @param direction Direction
 * @param theme Spacing from theme
 *
 * @return CSS spacing properties
 */
var getSpacing = function getSpacing(props, direction, theme // TODO: ADSWEB-780 separate interface?
) {
  var spacing = {};
  if (!theme) return spacing;
  if (props.m) spacing.margin = props.m === 'auto' ? 'auto' : theme[props.m];
  var mty = props.mt || props.my;
  if (mty) spacing.marginTop = mty === 'auto' ? 'auto' : theme[mty];
  var mex = props.me || props.mx;
  if (mex) spacing[marginEndMap[direction]] = mex === 'auto' ? 'auto' : theme[mex];
  var mby = props.mb || props.my;
  if (mby) spacing.marginBottom = mby === 'auto' ? 'auto' : theme[mby];
  var msx = props.ms || props.mx;
  if (msx) spacing[marginStartMap[direction]] = msx === 'auto' ? 'auto' : theme[msx];
  if (props.p) spacing.padding = theme[props.p];
  var pty = props.pt || props.py;
  if (pty) spacing.paddingTop = theme[pty];
  var pex = props.pe || props.px;
  if (pex) spacing[paddingEndMap[direction]] = theme[pex];
  var pby = props.pb || props.py;
  if (pby) spacing.paddingBottom = theme[pby];
  var psx = props.ps || props.px;
  if (psx) spacing[paddingStartMap[direction]] = theme[psx];
  return spacing;
};
var getSpacingUtility = function getSpacingUtility(props, direction) {
  return [toCx('m', props.m), toCx('mx', props.mx), toCx('my', props.my), toCx('mb', props.mb), toCx('mt', props.mt), toCx(direction === 'rtl' ? 'ml' : 'mr', props.me), toCx(direction === 'rtl' ? 'mr' : 'ml', props.ms), toCx('p', props.p), toCx('px', props.px), toCx('py', props.py), toCx('pb', props.pb), toCx('pt', props.pt), toCx(direction === 'rtl' ? 'pl' : 'pr', props.pe), toCx(direction === 'rtl' ? 'pr' : 'pl', props.ps)];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var withSpacing = function withSpacing(type) {
  var styledFunction = styled[type];
  return styledFunction(function (spacingProps) {
    return {
      margin: spacingProps.margin,
      marginTop: spacingProps.marginTop,
      marginLeft: spacingProps.marginLeft,
      marginBottom: spacingProps.marginBottom,
      marginRight: spacingProps.marginRight,
      padding: spacingProps.padding,
      paddingTop: spacingProps.paddingTop,
      paddingLeft: spacingProps.paddingLeft,
      paddingBottom: spacingProps.paddingBottom,
      paddingRight: spacingProps.paddingRight
    };
  });
};
var extractMargins = function extractMargins(props) {
  var m = props.m,
    mt = props.mt,
    mb = props.mb,
    mx = props.mx,
    my = props.my,
    ms = props.ms,
    me = props.me,
    rest = _objectWithoutProperties(props, _excluded);
  var margins = {
    m: m,
    mt: mt,
    mb: mb,
    mx: mx,
    my: my,
    ms: ms,
    me: me
  };
  return {
    margins: margins,
    rest: rest
  };
};
var extractPaddings = function extractPaddings(props) {
  var p = props.p,
    pt = props.pt,
    pb = props.pb,
    px = props.px,
    py = props.py,
    ps = props.ps,
    pe = props.pe,
    rest = _objectWithoutProperties(props, _excluded2);
  var paddings = {
    p: p,
    pt: pt,
    pb: pb,
    px: px,
    py: py,
    ps: ps,
    pe: pe
  };
  return {
    paddings: paddings,
    rest: rest
  };
};
var paddingPropsArray = ['p', 'pe', 'pb', 'pt', 'px', 'ps', 'py'];
var extractMarginsAndPaddings = function extractMarginsAndPaddings(props) {
  var _extractMargins = extractMargins(props),
    margins = _extractMargins.margins,
    restFromMargin = _extractMargins.rest;
  var _extractPaddings = extractPaddings(restFromMargin),
    paddings = _extractPaddings.paddings,
    rest = _extractPaddings.rest;
  return {
    margins: margins,
    paddings: paddings,
    rest: rest
  };
};

export { extractMargins, extractMarginsAndPaddings, extractPaddings, getSpacing, getSpacingUtility, paddingPropsArray, withSpacing };
//# sourceMappingURL=spacing.js.map
